export default __webpack_public_path__ + "assets/4692c32b7a3da0c90b16af9b4c511dc5.svg";